import Marketplace from './Marketplace.view';

export default Marketplace;
